export default __webpack_public_path__ + "static/media/ImageFive.34f73e51.jpg";